<script>

	import format from 'string-format'
	import {Line, mixins} from 'vue-chartjs'
	import zoomPlugin from 'chartjs-plugin-zoom'
	import {Plate} from "../../../models"
	import {LOAD_WELL_TARGET_DATA} from "../../../store/modules/plate"
	import {mapActions} from "vuex"

	const {reactiveProp} = mixins

	export default {
		name: "plate-target-chart",
		extends: Line,

		data: function () {
			return {

				component_name: 'PlateTargetChart',

				store_mutation_unsubscriber: null,

				// рисуемые лунки, dict[well_num, dataset_i]
				wells: {},

				// для проверки повторной загрузки данных
				loaded_wells: {},

				// диапазон значений для оси y
				probe_min: 0,
				probe_max: 0,

				data: {
					labels: ['cyc1', 'cyc2', 'cyc3'],

					// two dimensional array by row (wells) x col (probes)
					datasets: [
						{
							tension: 0,
							label: 'line1',
							borderColor: 'red',
							borderWidth: 1,
							fill: false,
							data: [1, 3, 7],
						},
						{
							label: 'line2',
							borderColor: 'blue',
							borderWidth: 1,
							fill: false,
							data: [10, -2, -1],
						}]
				},

				options: {
					respoinsive: true,
					animation: {duration: 0,},
					events: ['mousedown', 'mouseup', 'mousemove', 'mousewheel',],
					maintainAspectRatio: false,

					legend: {display: false,},
					tooltips: {display: false,},

					scales: {
						yAxes: [{type: 'linear', position: 'left',},],
					},

					plugins: {
						select: {
							events: ['mousedown', 'mouseup',],
							selectCallback: function (startPoint, endPoint) {
								console.debug('PlateTargetChart.selectCallback()')
							},
						},

						zoom: {
							pan: {
								enabled: false,
								mode: 'xy',
							},
							zoom: {
								enabled: true,
								drag: true,

								mode: 'xy',

								rangeMin: {},
								rangeMax: {},
							}
						},
					}
				},
			}
		},

		props: {
			disabled: {type: Boolean, default: false,},
			plate: {type: Plate, default: () => Plate.empty_plate},
			selected_wells: {type: Array, default: () => []},
			selected_probes: {type: Array, defult: () => []},
		},

		watch: {
			plate: function (new_value, old_value) {
				console.debug(format("PlateTargetChart.watch.plate() plate_id={0}", this.plate.id))
				this.update_chart()
			},

			selected_wells: function (new_wells, old_wells) {
				console.debug("PlateTargetChart.watch.selected_wells()")
				this.build_view(
					new_wells, this.selected_probes,
					old_wells, this.selected_probes)
			},

			selected_probes: function (new_probes, old_probes) {
				console.debug("PlateTargetChart.watch.selected_probes() ")
				this.build_view(
					this.selected_wells, new_probes,
					this.selected_wells, old_probes)
			},

			disabled: function (new_value, old_value) {
				console.debug(format("PlateTargetChart.watch.disabled({0})", this.disabled))
				this.build_view(
					this.selected_wells, this.selected_probes,
					this.selected_wells, this.selected_probes)
			},
		},

		created() {
			const me = this
			this.store_mutation_unsubscriber = this.$store.subscribe(
				function (mutation, state) {
					me.store_mutation_handler(mutation, state)
				})
		},

		methods: {
			...mapActions({
				message_add: 'message/add'
			}),

			store_mutation_handler: function (mutation, state) {
				// try {
				// 	if (mutation.type === 'plate/' + LOAD_WELL_TARGET_DATA) {
				// 		const well_num = mutation.payload.well.well_num
				// 		this.load_well_target_data(well_num)
				// 	}
				// } catch (error) {
				// 	// нельзя выбрасывать исключения в обработчиках мутаций,
				// 	// иначе в action случится повторная установка данных на пустые
				// 	console.error(error)
				// 	// console.trace()
				// }
			},

			load_well_target_data: function (well_num) {
				console.debug(format(
					"PlateTargetChart.load_well_target_data( #{well_num} )",
					{well_num: well_num}))

				const well = this.plate.wells[well_num]

				// для проверки двойной загрузки данных лунок
				if (!(well_num in this.loaded_wells)) {
					this.loaded_wells[well_num] = well
				} else {
					console.error(format("Double loaded #{0}", well_num))
				}

				// событие обновления прилетает для лунки,
				// а значит надо обновить графики всех зондов лунки
				for (let sp_i = 0; sp_i < this.selected_probes.length; sp_i++) {
					const probe = this.plate.probes[this.selected_probes[sp_i]]

					if (well.probe_data != null && probe.id in well.probe_data) {
						this.data.datasets[this.wells[well_num] + sp_i] =
							this.get_well_probe_dataset(this.plate.wells[well_num], probe)
					} else {
						this.data.datasets[this.wells[well_num] + sp_i] = {}
					}
				}

				this.update()
			},

			get_well_probe_dataset: function (well, probe) {

				return {
					tension: 0,
					borderColor: probe.color != null ? probe.color
						: probe.dye.color != null ? probe.dye.color
							: 'gray',
					borderWidth: 1,
					pointRadius: 1,
					pointHoverRadius: 2,
					fill: false,
					data: well.probe_data != null ? well.probe_data[probe.id] : [],
				}
			},

			build_view: function (new_wells, new_probes, old_wells, old_probes) {

				// for (let old_sw_i = 0; old_sw_i < old_wells.length; old_sw_i++)
				// 	for (let old_p_i = 0; old_p_i < old_probes.length; old_p_i++) {
				// 		const old_well_num = old_wells[old_sw_i]
				// 		const old_well = this.plate.wells[old_well_num]
				// 		const old_probe = old_probes[old_p_i]
				//
				// 		if (old_well && !old_well.empty) {
				//
				// 			delete this.wells[old_well_num]
				// 		}
				// 	}


				// for (let new_sw_i = 0; new_sw_i < new_wells.length; new_sw_i++)
				// 	for (let new_p_i = 0; new_p_i < new_probes.length; new_p_i++) {
				// 		const new_well_num = new_wells[new_sw_i]
				// 		const new_well = this.plate[new_well_num]
				// 		const new_probe = new_probes[new_p_i]
				// 	}

				this.update_chart()
			},

			update_well_chart: function (well_num) {

			},

			update_chart: function () {
				console.debug("PlateTargetChart.update_chart()")

				this.data.labels = Array.from(
					[...Array(this.plate.points.length).keys()],
					(c) => c + 1)

				this.wells = {}
				this.loaded_wells = {}
				this.data.datasets = new Array(
					this.selected_wells.length * this.selected_probes.length)

				// Fill in chart dataset items with {}
				for (let sw_i = 0; sw_i < this.selected_wells.length; sw_i++) {
					const well_num = this.selected_wells[sw_i]
					const well_base = this.wells[well_num] = sw_i * this.selected_probes.length

					for (let sp_i = 0; sp_i < this.selected_probes.length; sp_i++) {
						this.data.datasets[well_base + sp_i] = {}
					}
				} //sw_i - wells

				if (!this.disabled) {
					for (let sw_i = 0; sw_i < this.selected_wells.length; sw_i++) {
						const well_num = this.selected_wells[sw_i]
						const well = this.plate.wells[well_num]

						if (well.probe_data != null) {
							this.update_well_chart(well_num)
						}
					} // sw_i - wells

					// for (let sw_i = 0; sw_i < this.selected_wells.length; sw_i++) {
					// 	const well_num = this.selected_wells[sw_i]
					// 	const well = this.plate.wells[well_num]
					//
					// 	for (let sp_i = 0; sp_i < this.selected_probes.length; sp_i++) {
					// 		const probe = this.plate.probes[this.selected_probes[sp_i]]
					//
					// 		if (well.probe_data != null && probe.id in well.probe_data) {
					//
					// 			const well_probe_ds = this.get_well_probe_data(well, probe)
					// 			ds[sw_i * this.selected_probes.length + sp_i] = well_probe_ds
					// 		} else {
					// 			ds[sw_i * this.selected_probes.length + sp_i] = {}
					// 		}
					// 	} // sp_i - probes
					//
					// 	this.wells[well_num] = sw_i * this.selected_probes.length
					// }  // sw_i - wells
				} // disabled

				// this.options.plugins.zoom.zoom.rangeMin.y = this.plate.spectra_min
				// this.options.plugins.zoom.zoom.rangeMax.y = this.plate.spectra_max
				this.refresh()
			},

			refresh: function () {
				const me = this

				if (!this.disabled) {
					if (this.$refs.canvas) {
						this.renderChart(this.data, this.options)
					} else {
						console.warn(format(
							"PlateTargetChart.refresh( this='{0}', this.$refs.canvas={1} )",
							me.constructor.name,
							this.$refs.canvas))
					}
				}
			},

			reset: function () {
				try {
					this.$data._chart.resetZoom()
				} catch (error) {
					this.message_add(error)
				}
			},
		},
	}
</script>

<style scoped>

</style>